import { safeSessionRead, safeSessionWrite } from '../../infra/storage';
import { PERIOD_SHORTCUTS, periodRange } from './period.types';
/**
 * O ULTIMO periodo escolhido, lembrado para o painel inteiro (B-35).
 *
 * Decidido em 14/10/2026 (relatos 5 e 6): ao voltar ao Dashboard pelo menu, o periodo
 * voltava ao padrao e tinha de ser escolhido de novo. Agora o ultimo periodo escolhido
 * em QUALQUER seletor que lembra vira o padrao de todos eles, na mesma tela ou em
 * outra.
 *
 * Na SESSAO da pagina, e nao no endereco nem no servidor: e o contexto de trabalho de
 * agora. O endereco continua mandando - um link com periodo abre nesse periodo, e a
 * lembranca so vale quando o endereco nao diz nenhum.
 *
 * So entra o que a pessoa ESCOLHEU (um atalho, uma data digitada). O periodo que chega
 * por link nao e lembrado: abrir o link de um colega nao muda o padrao de quem abriu.
 */
const KEY = 'mormaii.period';
/*
 * Uma copia em memoria, alem da sessao: o teste roda sem `sessionStorage`, e a leitura
 * nao precisa ir ao armazenamento a cada viagem.
 */
let last;
export function rememberPeriod(period) {
    last = period;
    safeSessionWrite(KEY, JSON.stringify(period));
}
/** Esquece a lembranca. Para teste, e para quem sai da sessao. */
export function forgetPeriod() {
    last = undefined;
}
function read() {
    if (last) {
        return last;
    }
    const raw = safeSessionRead(KEY);
    if (!raw) {
        return undefined;
    }
    try {
        const parsed = JSON.parse(raw);
        if (!parsed.shortcut || !PERIOD_SHORTCUTS.includes(parsed.shortcut)) {
            return undefined;
        }
        last = { shortcut: parsed.shortcut, from: parsed.from ?? '', to: parsed.to ?? '' };
        return last;
    }
    catch {
        return undefined;
    }
}
/**
 * O periodo lembrado, traduzido para os atalhos DESTE seletor.
 *
 * Um atalho que o seletor tem entra como atalho, com as datas de HOJE: os atalhos sao
 * relativos, e "Ultimos 7 dias" lembrado ontem continua sendo os ultimos 7 dias. Um que ele
 * nao tem ("Este mes" onde nao existe) entra com as MESMAS datas, em "Escolher datas".
 * O teto de cada tela (o Relatorio de Sono corta em 35 dias) e aplicado por quem
 * mostra, como em qualquer outro periodo.
 *
 * `undefined` quando nao ha lembranca, ou quando ela e "todo o periodo" num seletor que
 * nao o oferece - ai vale o padrao da tela.
 */
export function recallPeriod(shortcuts) {
    const remembered = read();
    if (!remembered) {
        return undefined;
    }
    if (remembered.shortcut !== 'custom' && shortcuts.includes(remembered.shortcut)) {
        return { shortcut: remembered.shortcut, ...periodRange(remembered.shortcut) };
    }
    // Datas fixas: as que foram digitadas, ou as do atalho que este seletor nao tem.
    const range = remembered.shortcut === 'custom'
        ? { from: remembered.from, to: remembered.to }
        : periodRange(remembered.shortcut);
    if (!range.from || !range.to || !shortcuts.includes('custom')) {
        return undefined;
    }
    return { shortcut: 'custom', from: range.from, to: range.to };
}
//# sourceMappingURL=period-memory.js.map